import Vue from 'vue'
import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'


export const MODULE_NAME = 'mun-meh'

export const createPublicationMunMehModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "PublicationMunMehModal" */
    './components/PublicationMunMehModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createPublicationMunMehDataModal = (
  parent: Vue,
  propsData: Record<string, unknown>,
) => {
  const AsyncComponent = import(
    /* webpackChunkName: "PublicationMunMehDataModal" */
    './components/PublicationMunMehDataModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createPublicationMunMehImportModal = (
  parent: Vue,
  propsData: Record<string, unknown>,
) => {
  const AsyncComponent = import(
    /* webpackChunkName: "PublicationMunMehImportModal" */
    './components/PublicationMunMehImportModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createPublicationMunMehDeleteExpert1Modal = (
  parent: Vue,
  propsData: Record<string, unknown>,
) => {
  const AsyncComponent = import(
    /* webpackChunkName: "PublicationMunMehDeleteExpert1Modal" */
    './components/PublicationMunMehDeleteExpert1Modal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
